module.exports = __webpack_public_path__ + "img/default-question-incidents.28b0e3a7.svg";